<div class="section p-3">
        <dx-data-grid
          #dataGridManageUser
          id="dataGridManageUser"
          class="manage-user-grid"
          [dataSource]="manageUsersData"
          [allowColumnResizing]="true" 
        [columnResizingMode]="'widget'" 
        [hoverStateEnabled]="true"
        [columnAutoWidth]="true" 
        [allowColumnReordering]="true"
        (onEditingStart)="onEditingStart($event)"
        (onEditCanceled)="onEditCanceled($event)"
          [showBorders]="true"
          (onInitNewRow)="onAddUser($event)"
          (onSaved)="updateUsers($event)"
        >
        
  <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-paging [pageSize]="100000" emptyPanelText=""></dxo-paging>
          <!-- <dxo-row-dragging
            [allowReordering]="!locked"
            [showDragIcons]="false"
            [onReorder]="true"
            [data]=""
            newRowPosition="last"
        ></dxo-row-dragging> -->
          
          <dxo-editing
            mode="form"
            [allowUpdating]="true"
            [allowAdding]="true"
            [selectTextOnEditStart]="true"
            [allowDeleting]="true"
            *ngIf="!disManageUsers"
          >
          <dxo-form [customizeItem]="customizeItem"></dxo-form>  

          </dxo-editing>

          <dxi-column type="buttons" *ngIf="!locked" [width]="60">
            <dxi-button name="delete"></dxi-button>
            <dxi-button name="edit"></dxi-button>
        </dxi-column> 

        <dxi-column dataField="searchParam" caption="Search Email" [allowEditing]="!editRow" [visible]="false">
          <dxi-validation-rule
            type="custom"
            [validationCallback]="searchParamValidation"
          ></dxi-validation-rule>
        </dxi-column>
        
        <dxi-column dataField="speId" caption="SPE ID" [allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            [message]="customIDMsg"
            [validationCallback]="customIDValidation"
          ></dxi-validation-rule>
        </dxi-column>
        
        <dxi-column dataField="firstName" caption="FIRST NAME" [allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>

        <dxi-column dataField="roleId" 
        dataType="string" 
        caption="ROLE"  
        [allowEditing]="true"  
        editCellTemplate="changeRoleName">
          <dxo-lookup 
            [dataSource]="roleNameData" 
            valueExpr="roleId" 
            displayExpr="roleName">
          </dxo-lookup> 
          <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
     
     <div *dxTemplate="let cellInfo of 'changeRoleName'">
       <dx-select-box
        [dataSource]="roleNameData"
         [value]="cellInfo.value"
         displayExpr="roleName"
         valueExpr="roleId"
         (onValueChanged)="updateRoleName($event, cellInfo)"
       >
     </dx-select-box>
     </div> 

     <dxi-column dataField="lastName" caption="LAST NAME" [allowEditing]="false">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

<dxi-column dataField="departmentId" 
dataType="string" 
caption="DEPARTMENT"  
[allowEditing]="true"   
editCellTemplate="changeDeptName">
  <dxo-lookup 
    [dataSource]="departmentData" 
    valueExpr="picklistDetailId" 
    displayExpr="value">
  </dxo-lookup>
  <dxi-validation-rule type="required"></dxi-validation-rule>
</dxi-column>

<div *dxTemplate="let cellInfo of 'changeDeptName'">
<dx-select-box
[dataSource]="departmentData"
[value]="cellInfo.value"
 displayExpr="value"
 valueExpr="picklistDetailId"
 (onValueChanged)="updateDeptName($event, cellInfo)"
>
</dx-select-box>
</div>
        
       
        
        <dxi-column dataField="email" caption="EMAIL"[allowEditing]="false">
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="email"></dxi-validation-rule>
          <dxi-validation-rule
            type="custom"
            message="Email is associated with an existing user."
            [validationCallback]="customValidation"
          ></dxi-validation-rule>
        </dxi-column>
         <!-- Start added for wedaccessRestrict -->
        <!-- <dxi-column dataField="wednesdayAccessFlag"
            dataType="boolean"
            caption="Restricted Access"
            [allowEditing]="true"
            [visible]="false"
              >
              <dxo-form-item 
              editorType = "dxCheckBox"
              [editorOptions] = "{ height: 50 }">
              <dxo-label location="left" text="Restricted Access(Wednesday)" ></dxo-label>
  </dxo-form-item>
</dxi-column> -->
 <!-- End of added for wedaccessRestrict-->
               
               <!-- <dxi-column dataField="wednesdayAccessFlag" cellTemplate="cellTemplate"></dxi-column>   -->
               <!-- <div *dxTemplate="let data of 'cellTemplate'">  
                <input #cb type="checkbox" [(ngModel)]="data.value" (change)="valuechange($event, data, cb.checked)" />  
              </div>   -->
        </dx-data-grid>
      
</div>

<app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>